import mockApi from '../../mocks/mockApi.json';

const planetsAPI = async () => mockApi;

export default planetsAPI;
